import { useEffect, useRef } from "preact/hooks";
import type { RefObject } from "preact";
import type { DrawObject } from "../types/document.ts";
import { render } from "../rendering/renderer.ts";

export function useRenderLoop(
  canvasRef: RefObject<HTMLCanvasElement | null>,
  objects: DrawObject[],
  inProgress: DrawObject | null,
  canvasWidth: number,
  canvasHeight: number,
): void {
  const rafId = useRef(0);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    if (inProgress !== null) {
      rafId.current = requestAnimationFrame(() => {
        render(ctx, objects, inProgress, canvasWidth, canvasHeight);
      });
      return () => cancelAnimationFrame(rafId.current);
    }

    render(ctx, objects, null, canvasWidth, canvasHeight);
  }, [canvasRef, objects, inProgress, canvasWidth, canvasHeight]);
}
